import * as React from "react";
const SvgForward = () => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 8.062a.54.54 0 0 0-.539-.539H1.538a.538.538 0 0 0 0 1.077h12.923A.54.54 0 0 0 15 8.062",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.558 3.158a.54.54 0 0 0 0 .761L13.7 8.062l-4.142 4.142a.538.538 0 0 0 .761.761l4.523-4.523a.54.54 0 0 0 0-.761L10.32 3.158a.54.54 0 0 0-.761 0",
    clipRule: "evenodd"
  }
));
export default SvgForward;
